import { Component, OnInit, AfterViewInit, ElementRef, ViewChildren, QueryList, ViewChild, Input, Output, EventEmitter } from "@angular/core";
import { RequestServices } from "../../services/request.service";
//import { MatSnackBar, MatDialog } from "@angular/material/snack-bar";
import { BuscadorCotizadorComponent } from "../../tools/buscador-cotizador/buscador-cotizador.component";
import { MatDialog } from '@angular/material/dialog';
import { NoEstaAutoComponent } from '../no-esta-auto/no-esta-auto.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Configuration } from 'src/app/Constants/configuration';
//import { ModalInfoVehiculoComponent } from "./modal-info-vehiculo/modal-info-vehiculo.component";

@Component({
    selector: "autos-busqueda",
    templateUrl: "./autos-busqueda.component.html",
    styleUrls: ['./autos-busqueda.component.css'],
    outputs: ['redirectDatos'],
    providers: [RequestServices]
})
export class AutosBusquedaComponent implements OnInit, AfterViewInit {
    cAseg: String;
    modelo: any = [];
    selectedVar: any;
    selectauto: any = {};
    auto: boolean = false;
    selectedOt: any;
    variable: String = "";
    public validText: any = { valid: true, msj: "" };
    public searchResult: Array<any> = Array<any>();
    public searchEnabled = false;
    public strSearch = "";
    apiName: String = "QuattroAutosBuscador";
    searcher: string = "";
    abrevia: String = "";
    currentYear: number = new Date().getFullYear();
    //amis: string = "00000"; // Default
    datos: any = {
        'v1': "",   //cp
        'v2': "",   //edad
        'v3': 1,   //sexo
        'v4': 1,   //persona
        'v5': 1,   //valor
        'v6': ""    //dcto
    };
    dataDetalle: any = {};
    cpValidate: boolean = false;
    habilitarBoton: boolean = false;
    contenidoModal: string = "";
    @Output() dataSalida = new EventEmitter();
    @Output() dataAutoSalida = new EventEmitter();
    @Input('focus') focus: boolean = false;
    @Input('amis') amis: string = "";
    @Input('aseguradoraId') aseguradoraId: number = 0;
    @Input('datosAuto') datosAuto: any;
    @Input('searchCpAPI') searchCpAPI: any = "";
    @Input('pathUrlAPI') pathUrlAPI: any = "";
    @Input('modeloAuto') modeloAuto: number = 0;
    @Input('pickup') pickup: number = 0;
    @Input('wkstId') wkstId: string = '';
    @Input('negocioId') negocioId: number = 0;
    @Input('tipoVehiculoBuscador') tipoVehiculoBuscador: number = 0;
    @ViewChildren('inputOtroModelo') inputOtroModeloElements: QueryList<ElementRef>;
    @ViewChild('buscadorCotizador') buscadorCotizador: BuscadorCotizadorComponent;
    remoteName:string = "Prueba";
    public const: Configuration = new Configuration();
    tipoUnidad = 0;

    constructor(
        private modal: MatDialog,
        private snackBar: MatSnackBar
        /*private requestService: RequestServices,
    public dialog: MatDialog*/) { }

    ngOnInit(): void {
        try {
            //this.mworkSiteParametros(108)
            let fecha: Date = new Date();
            fecha.setFullYear(fecha.getFullYear() + 1);
            for (let i = 0; i < 23; i++) {
                this.modelo.push({ "modelo": fecha.getFullYear() });
                fecha.setFullYear(fecha.getFullYear() - 1);
            }
            this.selected(this.currentYear, 0);   
        } catch (error) {
            this.snackBar.open("AutosBusquedaComponent.ngOnInit().error", error, { duration: this.const.SNACK_BARTIME });
        }
    }

    ngAfterViewInit(): void {
        try {
            if(this.focus){
                setTimeout(() => {
                    this.buscadorCotizador.buscadorSioCot.nativeElement.focus();
                }, 500);
            }   
        } catch (error) {
            this.snackBar.open("AutosBusquedaComponent.ngAfterViewInit().error", error, { duration: this.const.SNACK_BARTIME });
        }
    }

    setDatosAuto() {
        try {
            this.datos = this.datosAuto.datos;
            if (this.datosAuto.detalle['101'] == '') {
                this.selected(this.currentYear, 0);
            } else {
                this.selectedVar = this.datosAuto.detalle['101'];
                this.variable = this.datosAuto.detalle['101'];
                this.buscadorCotizador.searchKeyUp({ target: { value: this.datosAuto.detalle['108'] }, keyCode: 0 });
            }   
        } catch (error) {
            this.snackBar.open("AutosBusquedaComponent.setDatosAuto().error", error, { duration: this.const.SNACK_BARTIME });
        }
    }

    selected(modelo, idx) {
        try {
            this.selectedVar = modelo;
            this.selectedOt = "";
            this.selectauto = {};
            this.redirectDatos();   
        } catch (error) {
            this.snackBar.open("AutosBusquedaComponent.selected().error", error, { duration: this.const.SNACK_BARTIME });
        }
    }

    selectedOtro(modelo, valor) {
        try {
            // this.selectauto = {};
            this.selectedOt = modelo;
            if (valor != "") {
                this.openSearcher(valor);
                // this.redirectDatos();
                setTimeout(() => {
                    this.inputOtroModeloElements.changes.subscribe(() => {
                        if (this.inputOtroModeloElements.length > 0) {
                            this.inputOtroModeloElements.last.nativeElement.focus();
                        }
                    });
                }, 400);
            }/* else{
                this.redirectDatos();
            } */   
        } catch (error) {
            this.snackBar.open("AutosBusquedaComponent.selectedOtro().error", error, { duration: this.const.SNACK_BARTIME });
        }
    }

    validarVariable() {
        try {
            let val: any = Number(this.variable);
            if (isNaN(Number(this.variable)) || Number(this.variable) == 0 || Number(this.variable) < 1900 || Number(this.variable) > new Date().getFullYear() + 1) {
                val = "Otro"//new Date().getFullYear();
            } else {
                val = Number(this.variable);
            }
            this.selectedVar = val;
            this.closeSearcher();   
        } catch (error) {
            this.snackBar.open("AutosBusquedaComponent.validarVariable().error", error, { duration: this.const.SNACK_BARTIME });
        }
    }

    validaKeyup(event) {
        try {
            /* let val;
            if (isNaN(Number(this.variable)) || Number(this.variable) == 0 || Number(this.variable) < 1900 || Number(this.variable) > new Date().getFullYear() + 1) {
                val = "Otro"//new Date().getFullYear();
            } else {
                val = Number(this.variable);
            }
            if (this.variable.length < 4) {
                this.validText.valid = true;
                this.validText.msj = "*Campo Requerido";
            } else if (this.variable.length == 4 && Number(this.variable) > 1900 && Number(this.variable) < new Date().getFullYear() + 1) {
                this.validText.valid = false;
                this.validText.msj = "";
            } else {
                this.validText.valid = true;
                this.validText.msj = "*Modelo invalido";
            } */
            let key = event.keyCode;
            if (key == 13) {
                this.selectedVar = this.variable;
                this.closeSearcher();
            }   
        } catch (error) {
            this.snackBar.open("AutosBusquedaComponent.validaKeyup().error", error, { duration: this.const.SNACK_BARTIME });
        }
    }

    openSearcher(c1: string) {
        try {
            this.searcher = c1;   
        } catch (error) {
            this.snackBar.open("AutosBusquedaComponent.openSearcher().error", error, { duration: this.const.SNACK_BARTIME });
        }
    }

    closeSearcher() {
        try {
            this.searcher = "";   
        } catch (error) {
            this.snackBar.open("AutosBusquedaComponent.closeSearcher().error", error, { duration: this.const.SNACK_BARTIME });
        }
    }
    getValidar(): boolean {
        let dato:boolean = true;
        try {
            if (this.selectedVar == undefined) {
                dato = false;
            }
            if (!this.auto) {
                dato = false;
            }   
        } catch (error) {
            this.snackBar.open("AutosBusquedaComponent.getValidar().error", error, { duration: this.const.SNACK_BARTIME });
            dato = false;
        }
        return dato;
    }

    onFocus() {
        try {
            this.auto = false;
            this.selectauto = {};
            this.dataSalida.emit({ "ok": null });   
        } catch (error) {
            this.snackBar.open("AutosBusquedaComponent.onFocus().error", error, { duration: this.const.SNACK_BARTIME });
        }
    }

    onKeyup(charsLength: any) {
        try {
            if (charsLength > 1) {
                this.auto = true;
            }   
        } catch (error) {
            this.snackBar.open("AutosBusquedaComponent.onKeyup().error", error, { duration: this.const.SNACK_BARTIME });
        }
    }

    eventKeyBoard(keyBoard: any) {
        try {
            if (keyBoard.target.value.length > 1) {
                this.auto = true;
                if (keyBoard.keyCode == 13) {
                    if (Object.keys(this.selectauto).length === 0) {
                        let descripcion = this.buscadorCotizador.buscadorSioCot.nativeElement.value;
                        let data = {
                            'c1': {
                                "c1": "00000",
                                "c2": "N/D",
                                "c3": descripcion,
                                "c4": "MARCA NO DISPONIBLE",
                                "c5": this.selectedVar,
                                "c6": "https://storage.googleapis.com/quattrocrm/marcas/MARCA_NODISPONIBLE.png",
                                "c7": 29
                            }
                        };
                        this.redirect(data);
                    }
                }
            }   
        } catch (error) {
            this.snackBar.open("AutosBusquedaComponent.eventKeyBoard().error", error, { duration: this.const.SNACK_BARTIME });
        }
    }
    redirect(event) {
        try {
            //console.log('redirect: evento ', event);
            this.selectauto = event.c1;
            this.tipoUnidad = event.c9;
            this.auto = true;
            try {
                this.buscadorCotizador.buscadorSioCot.nativeElement.blur();
            } catch (e) {
                console.error("error", e);
            }
            this.redirectDatos();
            this.selectAuto();   
        } catch (error) {
            this.snackBar.open("AutosBusquedaComponent.redirect().error", error, { duration: this.const.SNACK_BARTIME });
        }
    }

    selectAuto() {
        try {
            this.dataAutoSalida.emit({ "c1": this.selectauto, "tipoUnidad": this.tipoUnidad });
        } catch (error) {
            this.snackBar.open("AutosBusquedaComponent.selectAuto().error", error, { duration: this.const.SNACK_BARTIME });
        }
    }

    redirectDatos() {
        try {
            let error = 0;
            // CP
            if (this.datos.v1 == "" || this.datos.v1.length < 5) {
                error++;
            }
            // Edad
            if (this.datos.v2 == "") {
                error++;
            } else {
                if (isNaN(this.datos.v2)) {
                    error++;
                }
                if (Number(this.datos.v2) <= 0) {
                    error++;
                }
                if (Number(this.datos.v2) === 0) {
                    error++;
                }
                this.dataDetalle['103'] = String(this.datos.v2);
            }
            // Sexo
            if (this.datos.v3 == "") {
                error++;
            } else {
                this.dataDetalle['104'] = (this.datos.v3 == 1) ? "Hombre" : "Mujer";
            }
            //Persona
            if (this.datos.v4 == "") {
                error++;
            } else {
                this.dataDetalle['105'] = (this.datos.v4 == 1) ? "Física" : "Moral";
            }
            // Valor
            if (this.datos.v5 == "") {
                error++;
            } else {
                this.dataDetalle['106'] = String(this.datos.v5);
            }
            // Descuento
            if (this.datos.v6 != "") {
                let val = Number(this.datos.v6);
                if (isNaN(val)) {
                    this.datos.v6 = "0.00";
                }
                this.dataDetalle['107'] = String(this.datos.v6);
            } else {
                this.dataDetalle['107'] = '0';
            }
            if (!this.selectauto.c1) {
                error++;
            }
            if (!this.selectauto.c5) {
                error++;
            }
            if (!this.selectauto.c3) {
                error++;
            } else {
                let auxDesc = String(this.selectauto.c3);
                let descripcion = auxDesc.replace(/ *\([^)]*\) */g, "");
                if (descripcion.length > 60) {
                    this.dataDetalle['108'] = descripcion.substring(0, 60);
                } else {
                    this.dataDetalle['108'] = descripcion;
                }
            }
            if (error > 0) {
                this.dataSalida.emit({ "ok": null });
            } else {
                this.dataDetalle['100'] = this.selectauto.c1;
                this.dataDetalle['101'] = String(this.selectauto.c5);
                this.dataSalida.emit({ "ok": 12, "datos": this.dataDetalle });  //tipo de control para Cotizacion Form = 12
            }   
        } catch (error) {
            this.snackBar.open("AutosBusquedaComponent.redirectDatos().error", error, { duration: this.const.SNACK_BARTIME });
        }
    }

    goNoEstaMiAuto(){
        try {
            let modalAyuda = this.modal.open(NoEstaAutoComponent, { disableClose: false });   
        } catch (error) {
            this.snackBar.open("AutosBusquedaComponent.goNoEstaMiAuto().error", error, { duration: this.const.SNACK_BARTIME });
        }
    }
}